export const DefaultConfig = `name: Example Workflow
description: "This is an example workflow"
start: 2022-01-01
steps:`

export const StepConfigs: Record<string, string> = {
    input: `
  - name: Example Input Step
    type: input
    roles:
      - Contributor
    tableGrains:
      - field
      - field
    allowMultipleRows: false
    skipTable: false
    source:
      required: false
    dataSource:
      type: inline
      dataSourcePath: mssql://my_schema.my_table
      canInsert: true
    taskBreakdown:
      type: open
    view:
      elements:
        - type: text
          field: exampleA
        - type: text
          field: exampleB
        - type: text
          field: exampleC`,
    inputCycle: `
  - name: Example Input Step
    type: input-cycle
    isArbitrate: false
    roles:
      - Contributor
    tableGrains:
      - field
      - field
    allowMultipleRows: false
    source:
      required: false
    entityType:
      source: torch, overrides, or any schema name (e.g., apm, external)
      dataset: dataset or SCHEMA.TABLE_NAME
      idField: ID_to_pull_from
      where: "string"
    dataSource:
      type: inline
      dataSourcePath: mssql://my_schema.my_table
      canInsert: true
    taskBreakdown:
      type: open
    view:
      elements:
        - type: text
          field: exampleA
        - type: text
          field: exampleB
        - type: text
          field: exampleC`,
    correct: `
  - name: Example Correction Step
    type: correct
    roles:
      - Contributor
    source:
      required: false
    entityType:
      source: torch
      dataset: facility
      idField: TORCH_FACILITY_ID
    dataSource:
      type: inline
      dataSourcePath: mssql://my_schema.my_table
    taskBreakdown:
      type: open
    view:
      elements:
        - type: text
          field: exampleA
        - type: text
          field: exampleB
        - type: text
          field: exampleC`,
    correctCycle: `
  - name: Example Correction Step
    type: correct-cycle
    isArbitrate: false
    roles:
      - Contributor
    source:
      required: false
    entityType:
      source: torch
      dataset: facility
      idField: TORCH_FACILITY_ID
    dataSource:
      type: inline
      dataSourcePath: mssql://my_schema.my_table
    taskBreakdown:
      type: open
    view:
      elements:
        - type: text
          field: exampleA
        - type: text
          field: exampleB
        - type: text
          field: exampleC`,
    arbitrate: `
  - name: Example Arbitration Step
    type: arbitrate
    roles:
      - Reviewer
    fromDataSource:
      type: inline
      dataSourcePath: mssql://my_schema.my_table
    toDataSource:
      type: inline
      dataSourcePath: mssql://my_schema.my_table
    dupeCount: 2`,
    approve: `
  - name: Example Approve Step
    type: approve
    roles:
      - Reviewer
    dataSource:
      type: inline
      dataSourcePath: mssql://my_schema.my_table
      canInsert: true
    percentCoverage: 30
    continuous: true`,
    review: `
  - name: Example Review Step
    type: review
    roles:
      - Reviewer
    fromDataSource:
      type: derive
      derivativePath: mssql://my_schema.my_table_[user]
      dataSourcePath: mssql://my_schema.my_table
    toDataSource:
      type: inline
      dataSourcePath: mssql://my_schema.my_table
    percentCoverage: 30
    continuous: true`,
}
